import React from "react";
import {OrgSubAccounts} from "./org_sub_account";
import {OrgMembers} from "./org_members";
import {OrgManagers} from "./org_managers";
import {OrgInfo} from "./org_info";
import {OrgOrders} from "./org_orders";

export class OrganizationMenu extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
    }

    render() {
        //activeItem
        return (
            <div className="organization_tabs">
                <div className="menu_tab" data-menu-item="info" onClick={this.props.setMenuItem}>
                    Information
                </div>
                <div className="menu_tab" data-menu-item="sub_account" onClick={this.props.setMenuItem}>
                    Create Sub Account
                </div>
                <div className="menu_tab" data-menu-item="members" onClick={this.props.setMenuItem}>
                    Members
                </div>
                <div className="menu_tab" data-menu-item="manager" onClick={this.props.setMenuItem}>
                    Managers
                </div>
                <div className="menu_tab" data-menu-item="orders" onClick={this.props.setMenuItem}>
                    Orders
                </div>
            </div>
        )
    }
}

export class OrganizationContent extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
    }

    render() {
        console.log( this.props.currOrganization );
        switch( this.props.activeItem ) {
            case "sub_account":
                return <section className="organization_tab_content" data-content="sub_account"><OrgSubAccounts currOrganization={this.props.currOrganization} /></section>;
            case "members":
                return <section className="organization_tab_content" data-content="members"><OrgMembers currOrganization={this.props.currOrganization} /></section>;
            case "manager":
                return <section className="organization_tab_content" data-content="manager"><OrgManagers currOrganization={this.props.currOrganization} /></section>;
            case "orders":
                return <section className="organization_tab_content" data-content="orders"><OrgOrders currOrganization={this.props.currOrganization} /></section>;
            case "info":
            default:
                return <section className="organization_tab_content" data-content="info"><OrgInfo currOrganization={this.props.currOrganization} /></section>;
        }
    }
}